import { BrandCaptionLowerThirdEntity, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandCaptionLowerThirdUseVO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandCaptionLowerThirdUseVO.validationSchema(),
    BrandCaptionLowerThirdEntity
  );

  constructor(readonly value: RoomBrandCaptionLowerThirdUse) {
    JsonSchemaValidator.assert(
      RoomBrandCaptionLowerThirdUseVO.validation,
      value
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandCaptionLowerThird"],
      properties: {
        roomId,
        brandCaptionLowerThird: {
          instanceof: BrandCaptionLowerThirdEntity.name
        }
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandCaptionLowerThirdUse {
  roomId: RoomId;
  brandCaptionLowerThird: BrandCaptionLowerThirdEntity;
}
